import { VoteApi } from '../api/vote/VoteApi';
import { AnonymousUserContextType } from '../contexts/anonUser';
import { SessionContextType } from '../contexts/session';
import { VoteInSession } from '../models/Vote';

class UserController {
    public static populateUserVotes = async (
        sessionContext: SessionContextType,
    ): Promise<void> => {
        const votes = await VoteApi.getUserVotes(sessionContext.session);

        if (votes) {
            const sessionVotes: {
                [key: string]: VoteInSession;
            } = {};

            votes.forEach((vote) => {
                sessionVotes[vote.pollId] = {
                    voteId: vote.id,
                    optionId: vote.optionId,
                };
            });
            const newSession = {
                ...sessionContext.session,
                votes: sessionVotes,
            };

            sessionContext.setSession(newSession);
        }
    };

    public static populateAnonymousUserVotes = async (
        anonymousUserContext: AnonymousUserContextType,
    ): Promise<void> => {
        if (anonymousUserContext.anonUser.user) {
            const votes = await VoteApi.getAnonymousUserVotes(
                anonymousUserContext.anonUser.user.id,
            );

            if (votes) {
                const sessionVotes: {
                    [key: string]: VoteInSession;
                } = {};

                votes.forEach((vote) => {
                    sessionVotes[vote.pollId] = {
                        voteId: vote.id,
                        optionId: vote.optionId,
                    };
                });
                const newAnonymousUser = {
                    ...anonymousUserContext.anonUser,
                    votes: sessionVotes,
                };

                anonymousUserContext.setAnonUser(newAnonymousUser);
            }
        }
    };
}

export default UserController;
